import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { VistaAdminUsuarioComponent } from "./vista-admin-usuario/vista-admin-usuario.component";
import { AutorizacionService } from "./autorizacion.service";
import { AdministradorConflictosComponent } from "./administrador-conflictos/administrador-conflictos.component";

import { HomeComponent } from "./home/home.component";

import { AdministradorPreguntasComponent } from "./administrador-preguntas/administrador-preguntas.component";

import { PreguntasFrontComponent } from "./administrador-preguntas/preguntas-front/preguntas-front.component";

import { OkFrontPreguntasComponent } from "./administrador-preguntas/ok-front-preguntas.component";

import { NewhomeComponent } from "./newhome/newhome.component";
import { ResumenConflictosComponent } from './administrador-preguntas/resumen-conflictos/resumen-conflictos.component';
import { ResumenEncuestaComponent } from "./vista-admin-usuario/resumen-encuesta/resumen-encuesta.component";

import { ReporteEstadisticoComponent } from "./reportes/reporte-estadistico/reporte-estadistico.component";


const prueba = false;

const routes: Routes = [
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  {
    path: "login",
    component: LoginComponent
  },
  // {
  //   path: "",
  //   component: NewhomeComponent,
  //   canActivate: [AutorizacionService]
  // },
  {
    path: "administrar-usuario",
    component: VistaAdminUsuarioComponent,
    canActivate: [AutorizacionService]
  },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [AutorizacionService]
  },
  {
    path: "administradorconflictos",
    component: AdministradorConflictosComponent,
    canActivate: [AutorizacionService]
  }
  ,
  {
    path: "administradorpreguntas",
    component: AdministradorPreguntasComponent,
    canActivate: [AutorizacionService]
  }
  ,
  {
    path: "PreguntasFront",
    component: PreguntasFrontComponent,
    canActivate: [AutorizacionService]
  },
  {
    path: "ResumenConflictos",
    component: ResumenConflictosComponent,
    canActivate: [AutorizacionService]
  },
  {
    path: "EditorDePreguntasComplianceFase4",
    component: OkFrontPreguntasComponent,
    canActivate: [AutorizacionService]
  }
  ,
  {
    path: "inicio",
    component: NewhomeComponent,
    canActivate: [AutorizacionService]
  },
  {
    path: "resumenEncuesta",
    component: ResumenEncuestaComponent,
    canActivate: [AutorizacionService]
  },
  {
    path: "reporte-estadistico",
    component: ReporteEstadisticoComponent,
    canActivate: [AutorizacionService]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
